export const GrowthBookFeatureFlags = {
    OrderingPrepTime: 'ordering-prep-time',
    MobileMenuAtTopOfPage: 'mobile-menu-at-top-of-page',
    OopProductCardDesign: 'oop-product-card-design',
    DineInProductCardDesign: 'dine-in-product-card-design',
} as const;
